import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axiosInstance from '../config/axiosConfig';
import { AuthContext } from './authContext';

const ProfileContext = createContext();

export const useProfile = () => {
  const ctx = useContext(ProfileContext);
  if (!ctx) throw new Error('useProfile must be used within a ProfileProvider');
  return ctx;
};

export const ProfileProvider = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(false);

  const refreshProfile = useCallback(async () => {
    if (!currentUser) return;
    setProfileLoading(true);
    try {
      const res = await axiosInstance.get('/company/profile');
      const d = res.data?.entity;
      if (d) setProfile(d);
    } catch {
      // fail silently — consumers fall back to their own values
    } finally {
      setProfileLoading(false);
    }
  }, [currentUser]);

  // Fetch once on mount (and whenever the logged-in user changes)
  useEffect(() => { refreshProfile(); }, [refreshProfile]);

  return (
    <ProfileContext.Provider value={{ profile, profileLoading, refreshProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};
